var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from '@max/max';
import { PlatformType, getPlatformType } from '@nibfe/mkt-env-api';
import { useCommonInfos } from './useCommonInfos';
import { useCreateAppointment, useQueryAppointmentStatus } from '../apis/appointment';
import { reportJSInfo } from '@max/meituan-uni-report';
import msi from '@/utils/msi';
const isMRN = false;
const platform = getPlatformType();
const isDp = [PlatformType.dpApp, PlatformType.dpAppWebView].includes(platform);
const CALENDAR_SCENE_TOKEN = 'dd-2feed6b01d76054a'; // 日历权限 sceneToken
const DEFAULT_ALARM = 600; // 默认提前10分钟提醒
/**
 * 使用 msi 方法添加日历
 */
const useMsiAddCalendar = ({ subscribeConfig, appointmentTime, success, fail }) => {
    var _a, _b;
    console.log('[useMsiAddCalendar] 开始使用 msi 添加日历');
    const startTime = Math.floor(appointmentTime / 1000);
    const endTime = startTime + 3600;
    const alarmOffset = (_a = subscribeConfig.alarmOffset) !== null && _a !== void 0 ? _a : DEFAULT_ALARM;
    const subscribeParams = {
        _mt: {
            sceneToken: CALENDAR_SCENE_TOKEN
        },
        title: subscribeConfig.title || '抽奖提醒',
        description: subscribeConfig.description || '',
        url: subscribeConfig.url || '',
        startTime,
        endTime,
        alarm: false,
        alarmOffset: 0,
        switchToCalendar: false,
        // 是否调用系统日历，false 表示直接添加日历
        success: () => {
            success();
        },
        fail: (error) => {
            console.log('[useMsiAddCalendar] msi 添加日历失败', error);
            fail(error);
        },
        complete: (data) => {
            // console.log('[useMsiAddCalendar] msi 添加日历完成', data);
        }
    };
    if (typeof alarmOffset === 'number') {
        subscribeParams.alarm = true;
        subscribeParams.alarmOffset = alarmOffset;
    }
    // console.log('[useMsiAddCalendar] msi 日历预约参数', subscribeParams);
    try {
        console.log('[useMsiAddCalendar] 开始请求日历权限');
        (_b = msi === null || msi === void 0 ? void 0 : msi.authorize) === null || _b === void 0 ? void 0 : _b.call(msi, {
            scope: 'scope.calendarWrite',
            _mt: {
                sceneToken: CALENDAR_SCENE_TOKEN
            },
            success: () => {
                var _a;
                console.log('[useMsiAddCalendar] 日历权限请求成功，开始添加日历');
                (_a = msi === null || msi === void 0 ? void 0 : msi.addPhoneCalendar) === null || _a === void 0 ? void 0 : _a.call(msi, subscribeParams);
            },
            fail: (error) => {
                console.log('[useMsiAddCalendar] msi 日历权限请求失败', error);
                fail(error);
            }
        });
    }
    catch (error) {
        console.log('[useMsiAddCalendar] msi 方法调用异常', error);
        fail(error);
    }
};
/**
 * 处理日历预约
 */
const handleMsiSubscribe = (subscribeConfig, appointmentTime, showToast) => {
    const subscribeOptions = {
        subscribeConfig,
        appointmentTime,
        success: () => {
            console.log('日历预约成功');
            showToast({
                content: '预约成功，已添加到日历提醒'
            });
        },
        fail: (e) => {
            console.log('日历预约失败', e);
            if (isDp) {
                showToast({
                    content: '添加日历提醒失败，请确认已打开日历权限'
                }); // 点评不能短信预约
            }
            else {
                showToast({
                    content: '预约成功'
                }); // 美团预约时，短信预约成功后才会进行日历预约
            }
            reportJSInfo({
                secCategory: '[MCP-PERIODIC-REWARD]-calendarOpenError',
                level: 'info',
                error: e,
                tags: {
                    sceneToken: CALENDAR_SCENE_TOKEN
                }
            }).catch();
        }
    };
    useMsiAddCalendar(subscribeOptions);
};
export const useActivitySubscription = (marketingId, subscribeConfig) => {
    const { showToast } = useCommonInfos();
    const { request: createAppointment } = useCreateAppointment();
    const { request: queryAppointmentStatus } = useQueryAppointmentStatus();
    // 使用传入的配置或默认值
    const config = subscribeConfig || {};
    const reachId = config.reachId || '';
    const alarmOffset = config.alarmOffset || DEFAULT_ALARM;
    const alarmOffsetMs = alarmOffset * 1000;
    /**
     * 创建预约
     */
    const postActivitySubscribe = (appointmentTime) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        let isSuccess = false;
        let errorMessage = '';
        if (!appointmentTime || !marketingId)
            return {
                isSuccess: false
            };
        const realReachTime = appointmentTime - alarmOffsetMs;
        try {
            const response = yield createAppointment({
                marketingId,
                marketingIdType: 1,
                appointmentTime,
                reachId,
                realReachTime
            });
            isSuccess = (response === null || response === void 0 ? void 0 : response.success) && (response === null || response === void 0 ? void 0 : response.appointmentTime);
            errorMessage = (_a = response === null || response === void 0 ? void 0 : response.message) !== null && _a !== void 0 ? _a : '';
        }
        catch (error) {
            isSuccess = false;
            errorMessage = ((_b = error) === null || _b === void 0 ? void 0 : _b.message) || '预约失败，请重试';
        }
        return {
            isSuccess,
            errorMessage
        };
    });
    /**
     * 查询预约状态
     */
    const querySubscribe = useCallback((appointmentTime) => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        try {
            const response = yield queryAppointmentStatus({
                marketingId,
                appointmentTime,
                marketingIdType: 1
            });
            return {
                isSubscribed: (_c = response === null || response === void 0 ? void 0 : response.success) !== null && _c !== void 0 ? _c : false
            };
        }
        catch (error) {
            console.error('查询预约状态失败', error);
            return {
                isSubscribed: false
            };
        }
    }), [marketingId]);
    /**
     * 执行预约
     */
    const onSubscribe = useCallback((appointmentTime) => __awaiter(void 0, void 0, void 0, function* () {
        console.log('[onSubscribe] 开始执行预约');
        // 判断预约时间距离是否太近，如果小于提醒时间则直接提示
        const now = Date.now();
        const leftTime = appointmentTime - now;
        const isLessThanAlarmOffset = leftTime <= alarmOffsetMs;
        console.log('[onSubscribe] 时间检查', {
            now: new Date(now).toLocaleString(),
            leftTime,
            leftTimeMinutes: Math.floor(leftTime / 60000),
            alarmOffsetMs,
            isLessThanAlarmOffset
        });
        if (isLessThanAlarmOffset) {
            let minutes = Math.floor(leftTime / 60000);
            let content = minutes >= 1 ? `抢券将在${minutes}分钟后开始` : '抢券即将开始';
            content += '，别离开等待抢券吧~';
            console.log('[onSubscribe] 预约时间太近，提示用户', content);
            showToast({
                content
            });
            return false;
        }
        console.log('[onSubscribe] 开始创建预约');
        const { isSuccess, errorMessage } = yield postActivitySubscribe(appointmentTime);
        console.log('[onSubscribe] 创建预约结果', {
            isSuccess,
            errorMessage
        });
        if (!isSuccess) {
            const showContent = errorMessage || '预约失败，请重试~';
            console.log('[onSubscribe] 预约失败', showContent);
            showToast({
                content: showContent
            });
            return false;
        }
        // MRN 端处理日历预约
        if (isMRN) {
            console.log('[onSubscribe] 在 App 端，开始处理日历预约');
            if (appointmentTime) {
                handleMsiSubscribe(config, appointmentTime, showToast);
            }
            else {
                reportJSInfo({
                    secCategory: '[MCP-PERIODIC-REWARD]-calendarStartTimeError',
                    level: 'info',
                    content: '预约日历提醒，开始日期错误',
                    tags: {
                        sceneToken: CALENDAR_SCENE_TOKEN,
                        marketingId
                    }
                }).catch();
            }
        }
        else {
            // Web 端直接显示成功
            console.log('[onSubscribe] 在 Web 端，直接显示成功');
            showToast({
                content: '预约成功'
            });
        }
        console.log('[onSubscribe] 预约流程完成');
        return true;
    }), [postActivitySubscribe, showToast, config, marketingId]);
    return {
        onSubscribe,
        querySubscribe
    };
};
